// src/components/dashboard/companyadmin/DepartmentComparisonChart.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import DashboardCard from '../DashboardCard';

function DepartmentComparisonChart({ data, loading, onSelectDepartment }) {
  return (
    <DashboardCard
      title="Department Comparison — Participants (last 12 months)"
      icon="bi-bar-chart-steps"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No department data yet."
    >
      <div style={{ width: '100%', height: 280 }}>
        <ResponsiveContainer>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="departmentName" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Bar
              dataKey="participants"
              fill="#0d6efd"
              name="Participants"
              cursor="pointer"
              onClick={(entry) => onSelectDepartment({ id: entry.departmentId, name: entry.departmentName })}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="text-muted small mt-2">Click a bar to drill into that department.</div>
    </DashboardCard>
  );
}

export default DepartmentComparisonChart;
